import React from "react";
import aboutImg from "../assets/IMG_4497_2.jpg";

function Intro() {
  return (
    <section className="boot">
      <div className="boot-identity">
        <div className="boot-avatar-frame">
          <img
            src={aboutImg}
            alt="Trevor Harless rock climbing"
            className="boot-avatar"
          />
        </div>
        <div className="boot-identity-text">
          <h1 className="boot-name">Trevor Harless</h1>
          <p className="boot-role">Software Engineer</p>
        </div>
        <div className="boot-readme">
          <p>
            I'm a software engineer that focuses on building{" "}
            <strong>reliable</strong> and <strong>scalable</strong>{" "}
            applications.
          </p>
          <p>I enjoy solving complex problems.</p>
          <p>
            <span className="boot-readme-label">contact</span>{" "}
            <a href="mailto:trevorharless.dev@gmail.com">
              trevorharless.dev@gmail.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
